import type { DetailTabValue, ListTabFilter } from "./expeditions.types";

// ── List page tab config ───────────────────────────────────────────────────────

export const LIST_TAB_LABELS: Record<ListTabFilter, string> = {
  all: "All",
  active: "Active",
  open: "Open",
  planning: "Planning",
  completed: "Completed",
  cancelled: "Cancelled",
};

// ── Detail page tab config ─────────────────────────────────────────────────────

export const DETAIL_TABS: { value: DetailTabValue; label: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "route", label: "Route" },
  { value: "crew", label: "Crew" },
  { value: "expenses", label: "Expenses" },
  { value: "documents", label: "Documents" },
  { value: "log", label: "Log" },
];
